module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/play_default_224x126-2edffe25921a2c73d8b2620f6da0bb11.jpg";